import React, { VFC } from 'react';
import {
  Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2';
type LoanSimulatorChartProps = {
  borrowingCapacityForAnnuallyIncome: number,
  borrowingCapacityForEasyRepayment: number,
  theme_color: string,
}
function cssvar(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name);
}
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

let options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
    datalabels: {
      color: 'white',
      display: true,
      font: {
        weight: 'bold',
        size: `${
          document.querySelector('.menu.-sp') &&
          //  スマホ用のクラスのstyleがdisplay: noneであれば24pxそれ以外であれば12px
          document.defaultView.getComputedStyle(document.querySelector('.menu.-sp'), null).display == 'none' 
          ? '24px'
          : '12px'
        }`,
      },
      align: 'center',
      anchor: 'center',
      formatter: (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '万円';
      }
    },
  },
  scales: {
    x: {
      ticks: {
        color: [],
        font: {
          size: `${
            document.querySelector('.menu.-sp') &&
            //  スマホ用のクラスのstyleがdisplay: noneであれば14pxそれ以外であれば12px
            document.defaultView.getComputedStyle(document.querySelector('.menu.-sp'), null).display == 'none'
              ? '14px'
              : '12px'
          }`,
        },
      },
    },
    y: {
      ticks: {
        color: '#3C4043'
      },
      font: {
        size: 12,
      },
    },
  },
};

const labels = [['借入可能な額', '（年収基準）'], ['無理なく返済', '（返済基準）']];

const LoanSimulatorChart: VFC<LoanSimulatorChartProps> = (props) => {
  const {
    borrowingCapacityForAnnuallyIncome,
    borrowingCapacityForEasyRepayment,
  } = props

  const annuallyIncomeColor = cssvar('--' + props.theme_color +'-primary');
  const easyRepaymentColor = cssvar('--' + props.theme_color +'-secondary');
  options.scales.x.ticks.color = [ annuallyIncomeColor, easyRepaymentColor];

  const data = {
    labels,
    datasets: [
      {
        label: '',
        data: [borrowingCapacityForAnnuallyIncome, borrowingCapacityForEasyRepayment],
        backgroundColor: [ annuallyIncomeColor, easyRepaymentColor],
        borderRadius: 4,
      }
    ],
  };

  return <Bar data={data} options={options}  plugins={[ChartDataLabels]}/>;
}

export default LoanSimulatorChart
